import { useState } from "react";
import api, { apiErr } from "../lib/api";
import { toast } from "sonner";
import { Lightning, CircleNotch } from "@phosphor-icons/react";

export default function RunPipelineButton({ onDone, label = "Run Pipeline" }) {
  const [loading, setLoading] = useState(false);
  const run = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/pipeline/run");
      toast.success(`Pipeline done — ${data.signals_extracted} signals · ${data.instruments} instruments`);
      onDone?.();
    } catch (e) {
      toast.error(apiErr(e.response?.data?.detail));
    } finally { setLoading(false); }
  };
  return (
    <button data-testid="run-pipeline-btn" onClick={run} disabled={loading}
      className="brand-gradient text-white font-semibold text-sm rounded-full px-4 py-2.5 flex items-center gap-2 shadow-lg hover:opacity-90 disabled:opacity-60 transition-opacity duration-200">
      {loading ? <CircleNotch size={15} weight="bold" className="animate-spin" /> : <Lightning size={15} weight="fill" />}
      {loading ? "Running…" : label}
    </button>
  );
}
